import { HTTP_METHOD_POST } from '../../constants/httpMethod';
import { CREATE_ORDER_URL, PAY_URL, PAYMENT_SESSION_URL } from './constants';

export const createOrder = async (token, partnerId, phoneNumber, fixedFacialValue) => {
    const urlPhoneNumber = phoneNumber ? phoneNumber.replace('+', '%2B') : null;
    let url = `${CREATE_ORDER_URL}?partnerId=${partnerId}`;
    url = urlPhoneNumber ? url.concat(`&phoneNumber=${urlPhoneNumber}`) : url;
    url = url.concat(`&fixedFacialValue=${fixedFacialValue}`);

    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        return res.payload;
    } catch (error) {
        console.error('Error while creating order:', error);
        throw error;
    }
};

export const validateMerchantSession = async (token, url) => {
    try {
        const response = await fetch(PAYMENT_SESSION_URL, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ url })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        return JSON.parse(res.payload);
    } catch (error) {
        console.error('Merchant session validation error:', error);
        throw error;
    }
};

export const authorizePayment = async (token, appleToken, userInfo, partnerId, orderId) => {
    try {
        const response = await fetch(PAY_URL, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ appleToken, ...userInfo, partnerId, orderId })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        return res.payload.widgetLink;
    } catch (error) {
        console.error('Merchant session validation error:', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/services/applepay/utils.js